import { render, staticRenderFns } from "./publish-dialog.vue?vue&type=template&id=56516de5&"
import script from "./publish-dialog.vue?vue&type=script&lang=js&"
export * from "./publish-dialog.vue?vue&type=script&lang=js&"
import style0 from "./publish-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports